import _asyncToGenerator from "E:/code/nkyOrder/trunk/vantCommon/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import QRCodeVue from 'qrcode-vue';
import html2canvas from 'html2canvas';
import { decrypt, encrypt } from "@/assets/utils/cryptoUtil";
import { getUserAllInfo, getUserInfoByPatientid } from "@/api/module/user";
export default {
  components: {
    QRCodeVue: QRCodeVue
  },
  data: function data() {
    return {
      // 二维码内容
      recommendCodeUrl: '',
      // 邀请码
      inviteCode: '',
      // 医院名称
      hospitalName: window.g.VUE_APP_HOSPITALNAME,
      // 医院地址
      hospitalAddress: window.g.VUE_APP_ADDRESS,
      // 医院联系电话
      hospitalPhone: window.g.VUE_APP_PHONE,
      sellQrcode: false
    };
  },
  created: function created() {
    this.getUser();
    this.initQrcode();
  },
  methods: {
    //获取用户信息
    getUser: function getUser() {
      var _this = this;

      console.log("用户信息");
      var loginuser = JSON.parse(localStorage.getItem("loginuser"));
      getUserInfoByPatientid({
        patientid: this.$encruption(loginuser.patientid)
      }).then(function (res) {
        console.log("用户信息", res);

        if (res.data.sellQrcode == 1) {
          _this.sellQrcode = true;
        }
      });
    },
    initQrcode: function initQrcode() {
      this.ReferralCodeShow = true;
      var loginuser = JSON.parse(localStorage.getItem("loginuser")); // 加密用户ID字符串

      this.recommendCodeUrl = window.g.VUE_APP_RECOMMEND_CODE_URL + encodeURIComponent(loginuser.patientid);
    },
    // 保存页面为图片的函数
    saveAsImage: function saveAsImage() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.$refs.captureRef) {
                  try {
                    // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
                    html2canvas(_this2.$refs.captureRef, {
                      backgroundColor: '#ffffff',
                      //画出来的图片有白色的边框,不要可设置背景为透明色（null）
                      useCORS: true,
                      //支持图片跨域
                      scale: window.devicePixelRatio || 1 //设置放大的倍数

                    }).then(function (canvas) {
                      // 把生成的base64位图片上传到服务器,生成在线图片地址
                      var url = canvas.toDataURL("image/png"); // toDataURL: 图片格式转成 base64
                      //将图片下载到本地

                      _this2.imgUrl = url;
                      var a = document.createElement("a"); // 生成一个a元素

                      var event = new MouseEvent("click"); // 创建一个单击事件

                      a.download = name || "分享推荐码"; // 设置图片名称没有设置则为默认

                      a.href = _this2.imgUrl; // 将生成的URL设置为a.href属性

                      a.dispatchEvent(event); // 触发a的单击事件
                    });
                  } catch (error) {
                    console.error('保存图片失败:', error);
                  }
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};